import React, {FC} from "react"

import {Body} from "@irati/ui/src/Typography"
import {Deal} from "@irati/types"
import {useTheme} from "@irati/ui/src/global/useTheme"

import {ButtonRouterLink} from "@irati/ui/src/Link"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Position, ImageWrapper, Image, Wrapper} from "../styled"
import getRankingColor from "../getRankingColor"

interface ReportingDeal extends Deal {
  savingsAUD?: number
  savingsGBP?: number
  uniqueUsers?: number
}

interface Props {
  perk: ReportingDeal
  ranking: number
}

const TopPerk: FC<Props> = ({perk, ranking}) => {
  const theme = useTheme()

  return (
    <div>
      <Wrapper>
        <Position justifyContent="center" alignItems="center" bgColor={getRankingColor(ranking, theme)}>
          <Body color={theme.colors.greys.white}>#{ranking}</Body>
        </Position>
        <ImageWrapper>
          <Image src={perk.thumbnailImage} height="100px" width="100px" />
        </ImageWrapper>
      </Wrapper>
      <Body textAlign="center">{perk.brandName}</Body>
      <Flex justifyContent="center">
        <ButtonRouterLink tertiary app="perks" to={`/info/${perk.urlSlug}`}>
          <FormattedMessage id="admin.components.dashboard.reporting.costOfLiving.linkToPerk" />
        </ButtonRouterLink>
      </Flex>
    </div>
  )
}

export default TopPerk
